import { AxiosPromise, AxiosResponse } from 'axios'
import { Form, FormList, FormPayload, FormScopeEnum, PreviewPageType } from '@dev/ee-api/ee-api-models'

import { StartLoadingFormsParams } from '@/store/forms/actions'

import { request } from './request'

export const loadForms = (params?: StartLoadingFormsParams & { formScope: FormScopeEnum }): AxiosPromise<FormList> => {
    const { Forms } = request();
    return Forms.formsGet(params?.formTypes, params?.formSubtypes, params.formScope, params?.limit, params?.offset, params?.search, params.formsOrder ).then((resp): AxiosResponse<FormList> => resp);
};

export const deleteForm = (name: string): AxiosPromise<void> => {
    const { Forms } = request();
    return Forms.formsByNameDelete(name);
};

export const deleteArrayForms = (names: Array<string>): AxiosPromise<void> => {
    const { Forms } = request();
    return Forms.formsDeleterequestsPost(names);
};

export const loadForm = (name: string): Promise<Form> => {
    const { Forms } = request();
    return Forms.formsByNameGet(name).then((resp): Form => resp.data);
};

export const saveForm = (formPayload: FormPayload, name?: string): Promise<Form> => {
    const { Forms } = request();
    if (!name) {
        return Forms.formsPost(formPayload).then((resp): Form => resp.data);
    }
    return Forms.formsByNamePut(name, formPayload).then((resp): Form => resp.data);
};

export const copyForm = (name: string): Promise<Form> => {
    const { Forms } = request();
    return Forms.formsByNameCopyPost(name).then((resp): Form => resp.data);
};

export const formsPagePreview = (previewPageType: PreviewPageType): AxiosPromise<string> => {
    const { Forms } = request();
    return Forms.formsPreviewGet(previewPageType);
}